import { render } from "./App.vue?vue&type=template&id=5345a429&scoped=true&bindings={\"numExercises\":\"data\",\"maxFactor1\":\"data\",\"maxFactor2\":\"data\",\"excludeZeroes\":\"data\",\"excludeDuplicates\":\"data\",\"numColumns\":\"data\",\"numRows\":\"data\",\"selectedOperations\":\"data\",\"exercises\":\"data\",\"pageHeader\":\"data\",\"exerciseRows\":\"options\",\"maxNumExercises\":\"options\",\"numExercisesAdjusted\":\"options\",\"generateExercises\":\"options\",\"printWindow\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5345a429&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5345a429"

export default script